import { render, staticRenderFns } from "./EmployeeAttendance.vue?vue&type=template&id=21856584&"
import script from "./EmployeeAttendance.vue?vue&type=script&lang=js&"
export * from "./EmployeeAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports